import { useEffect, useLayoutEffect, useMemo, useState } from 'react';

import type { ReactNode } from 'react';

export type UseOrderDetailCardStateProps = {
  orderUuid: string;
};

export const useOrderDetailCardState = (
  props: UseOrderDetailCardStateProps,
) => {
  const { orderUuid } = props;

  const [selectedOrderItemUuid, setSelectedOrderItemUuid] = useState<
    string | undefined
  >(undefined);

  const [isCommentExpand, setIsCommentExpand] = useState(false);

  const [isFinancialDetailVisible, setIsFinancialDetailVisible] =
    useState(true);

  const [isNotificationVisible, setIsNotificationVisible] = useState(true);

  const [isAllHeaderOptionVisible, setIsAllHeaderOptionVisible] =
    useState(false);

  useLayoutEffect(() => {
    setSelectedOrderItemUuid(undefined);
    setIsCommentExpand(false);
  }, [orderUuid]);

  return {
    selectedOrderItemUuid,
    setSelectedOrderItemUuid,
    isCommentExpand,
    setIsCommentExpand,
    isFinancialDetailVisible,
    setIsFinancialDetailVisible,
    isNotificationVisible,
    setIsNotificationVisible,
    isAllHeaderOptionVisible,
    setIsAllHeaderOptionVisible,
  };
};

export type OrderDetailCardState = ReturnType<typeof useOrderDetailCardState>;

type OrderDetailCardStateProps = UseOrderDetailCardStateProps & {
  children?: (state: OrderDetailCardState) => ReactNode;
};

export const OrderDetailCardStateContainer = (
  props: OrderDetailCardStateProps,
) => {
  const { children, orderUuid } = props;

  const state = useOrderDetailCardState({ orderUuid });

  return children?.(state);
};
